import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();
const langs = {
  'en-US': 'en',
  'es-es': 'es',
  'pt-PT': 'pt',
};

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'mascot/game_list',
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'mascot/session',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      game_id: params.gameId,
      language: langs[params.lang as keyof typeof langs] || 'es',
      home_url: params.url,
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
  },
  converter,
};
